// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import { applyTypicalDayResponseTransformer, applyTypicalDayWithActivityResponseTransformer, createAvailabilityResponseTransformer, createCallResponseTransformer, createCommentResponseTransformer, createDiplomaResponseTransformer, createEventChildResponseTransformer, createEventEnrollmentResponseTransformer, createEventResponseTransformer, createEventWithActivityResponseTransformer, createMyEnrollmentResponseTransformer, createTeamDailyTaskResponseTransformer, createTemplateResponseTransformer, getInvitationResponseTransformer, getOpinionThreadResponseTransformer, getTrainerProfileResponseTransformer, listAdminParticipantsResponseTransformer, listAvailabilitiesResponseTransformer, listCallsResponseTransformer, listCommentsResponseTransformer, listEventChildrenResponseTransformer, listEventEnrollmentsResponseTransformer, listEventsResponseTransformer, listEventsWithActivityResponseTransformer, listForTeamResponseTransformer, listGestionnaireMeetingsMyScopeResponseTransformer, listGestionnaireMeetingsOngoingResponseTransformer, listGestionnaireMeetingsResponseTransformer, listInChargeEventsResponseTransformer, listInChargeEventsWithActivityResponseTransformer, listMeetingEnrollmentsResponseTransformer, listMeetingsResponseTransformer, listModularEventsResponseTransformer, listMyAvailabilitiesResponseTransformer, listMyDailyEventsResponseTransformer, listMyDailyEventsWithActivityResponseTransformer, listMyEnrollmentsResponseTransformer, listOwnPlanningEventsResponseTransformer, listOwnPlanningEventsWithActivityResponseTransformer, listParticipantOpinionsResponseTransformer, listParticipantsResponseTransformer, listPlanningEventsResponseTransformer, listPlanningEventsWithActivityResponseTransformer, listPublicEventsResponseTransformer, listPublicEventsWithActivityResponseTransformer, listPublicMeetingsResponseTransformer, listPublicModularEventsResponseTransformer, listSupervisorEventsResponseTransformer, listSupervisorEventsWithActivityResponseTransformer, listTeamDailyTasksResponseTransformer, listTemplateContentsResponseTransformer, listTemplatesResponseTransformer, listTypicalDayEventsResponseTransformer, listTypicalDayEventsWithActivityResponseTransformer, listUserDiplomasResponseTransformer, patchAdminParticipantResponseTransformer, patchAvailabilityResponseTransformer, patchCommentResponseTransformer, patchDiplomaResponseTransformer, patchEventResponseTransformer, patchEventWithActivityResponseTransformer, patchGestionnaireInvitationResponseTransformer, patchGestionnaireMeetingResponseTransformer, patchMyParticipationResponseTransformer, patchParticipantOpinionResponseTransformer, patchParticipantResponseTransformer, patchTeamDailyTaskResponseTransformer, patchTemplateResponseTransformer, patchTrainerProfileResponseTransformer, postOpinionThreadMessageResponseTransformer, reopenOpinionThreadResponseTransformer, resolveOpinionThreadResponseTransformer, retrieveAdminParticipantResponseTransformer, retrieveCommentResponseTransformer, retrieveEventResponseTransformer, retrieveEventWithActivityResponseTransformer, retrieveForTeamResponseTransformer, retrieveGestionnaireInvitationResponseTransformer, retrieveGestionnaireMeetingResponseTransformer, retrieveMeetingResponseTransformer, retrieveMeResponseTransformer, retrieveMyEnrollmentResponseTransformer, retrieveMyParticipationResponseTransformer, retrieveParticipantOpinionResponseTransformer, retrieveParticipantResponseTransformer, retrievePublicMeetingResponseTransformer, retrieveTeamDailyTaskResponseTransformer, retrieveTemplateResponseTransformer, scheduleTemplateResponseTransformer, updateCallResponseTransformer, updateCommentResponseTransformer, updateEventResponseTransformer, updateEventWithActivityResponseTransformer, updateParticipantOpinionResponseTransformer, updateParticipantResponseTransformer, updateTeamDailyTaskResponseTransformer, updateTemplateResponseTransformer, updateTrainerProfileResponseTransformer } from './transformers.gen';
import type { ApplyTypicalDayData, ApplyTypicalDayResponses, ApplyTypicalDayWithActivityData, ApplyTypicalDayWithActivityResponses, CancelCallData, CancelCallResponses, CopyEventToDaysData, CopyEventToDaysResponses, CreateActivityCategoryData, CreateActivityCategoryResponses, CreateActivityData, CreateActivityResponses, CreateActivityTopicData, CreateActivityTopicResponses, CreateAvailabilityData, CreateAvailabilityResponses, CreateCallData, CreateCallResponses, CreateCampaignData, CreateCampaignResponses, CreateCommentData, CreateCommentResponses, CreateCommentTagData, CreateCommentTagResponses, CreateDailyTaskData, CreateDailyTaskResponses, CreateDailyTaskTeamData, CreateDailyTaskTeamResponses, CreateDiplomaData, CreateDiplomaResponses, CreateEventChildData, CreateEventChildResponses, CreateEventData, CreateEventEnrollmentData, CreateEventEnrollmentResponses, CreateEventResponses, CreateEventWithActivityData, CreateEventWithActivityResponses, CreateMyEnrollmentData, CreateMyEnrollmentResponses, CreateRoomData, CreateRoomResponses, CreateTeamCategoryData, CreateTeamCategoryResponses, CreateTeamDailyTaskData, CreateTeamDailyTaskResponses, CreateTeamData, CreateTeamResponses, CreateTemplateData, CreateTemplateResponses, CreateTrackData, CreateTrackResponses, DeleteAvailabilityData, DeleteAvailabilityResponses, DestroyActivityCategoryData, DestroyActivityCategoryResponses, DestroyActivityData, DestroyActivityResponses, DestroyActivityTopicData, DestroyActivityTopicResponses, DestroyCommentData, DestroyCommentResponses, DestroyCommentTagData, DestroyCommentTagResponses, DestroyDailyTaskData, DestroyDailyTaskResponses, DestroyDailyTaskTeamData, DestroyDailyTaskTeamResponses, DestroyDiplomaData, DestroyDiplomaResponses, DestroyEventData, DestroyEventEnrollmentData, DestroyEventEnrollmentResponses, DestroyEventResponses, DestroyEventWithActivityData, DestroyEventWithActivityResponses, DestroyMyEnrollmentData, DestroyMyEnrollmentResponses, DestroyRoomData, DestroyRoomResponses, DestroyTeamCategoryData, DestroyTeamCategoryResponses, DestroyTeamDailyTaskData, DestroyTeamDailyTaskResponses, DestroyTeamData, DestroyTeamResponses, DestroyTemplateData, DestroyTemplateResponses, DestroyTrackData, DestroyTrackResponses, GestionnaireRequestMeetingAnonymizationData, GestionnaireRequestMeetingAnonymizationResponses, GestionnaireSyncMeetingFromIntranetData, GestionnaireSyncMeetingFromIntranetResponses, GetInvitationData, GetInvitationResponses, GetOpinionThreadData, GetOpinionThreadResponses, GetTrainerProfileData, GetTrainerProfileResponses, JoinInvitationData, JoinInvitationResponses, ListActivitiesData, ListActivitiesResponses, ListActivityCategoriesData, ListActivityCategoriesResponses, ListActivityTopicsData, ListActivityTopicsResponses, ListAdminParticipantsData, ListAdminParticipantsResponses, ListAvailabilitiesData, ListAvailabilitiesResponses, ListCallsData, ListCallsResponses, ListCampaignsData, ListCampaignsResponses, ListCentresRessourceData, ListCentresRessourceResponses, ListCommentsData, ListCommentsResponses, ListCommentTagsData, ListCommentTagsResponses, ListDailyTasksData, ListDailyTasksResponses, ListDailyTaskTeamParticipantsData, ListDailyTaskTeamParticipantsResponses, ListDailyTaskTeamsData, ListDailyTaskTeamsResponses, ListEventChildrenData, ListEventChildrenResponses, ListEventEnrollmentsData, ListEventEnrollmentsResponses, ListEventsData, ListEventsResponses, ListEventsWithActivityData, ListEventsWithActivityResponses, ListForTeamData, ListForTeamResponses, ListGestionnaireMeetingsData, ListGestionnaireMeetingsMyScopeData, ListGestionnaireMeetingsMyScopeResponses, ListGestionnaireMeetingsOngoingData, ListGestionnaireMeetingsOngoingResponses, ListGestionnaireMeetingsResponses, ListInChargeEventsData, ListInChargeEventsResponses, ListInChargeEventsWithActivityData, ListInChargeEventsWithActivityResponses, ListMeetingEnrollmentsData, ListMeetingEnrollmentsResponses, ListMeetingModulesData, ListMeetingModulesResponses, ListMeetingRolesData, ListMeetingRolesResponses, ListMeetingsData, ListMeetingsResponses, ListMeetingTypesData, ListMeetingTypesResponses, ListModularEventsData, ListModularEventsResponses, ListMyAvailabilitiesData, ListMyAvailabilitiesResponses, ListMyDailyEventsData, ListMyDailyEventsResponses, ListMyDailyEventsWithActivityData, ListMyDailyEventsWithActivityResponses, ListMyEnrollmentsData, ListMyEnrollmentsResponses, ListOrganisatriceStructuresData, ListOrganisatriceStructuresResponses, ListOwnPlanningEventsData, ListOwnPlanningEventsResponses, ListOwnPlanningEventsWithActivityData, ListOwnPlanningEventsWithActivityResponses, ListParticipantOpinionsData, ListParticipantOpinionsResponses, ListParticipantsData, ListParticipantsResponses, ListPlacesData, ListPlacesResponses, ListPlanningEventsData, ListPlanningEventsResponses, ListPlanningEventsWithActivityData, ListPlanningEventsWithActivityResponses, ListPublicEventsData, ListPublicEventsResponses, ListPublicEventsWithActivityData, ListPublicEventsWithActivityResponses, ListPublicMeetingsData, ListPublicMeetingsResponses, ListPublicModularEventsData, ListPublicModularEventsResponses, ListRoomsData, ListRoomsResponses, ListSupervisorEventsData, ListSupervisorEventsResponses, ListSupervisorEventsWithActivityData, ListSupervisorEventsWithActivityResponses, ListTeamCategoriesData, ListTeamCategoriesResponses, ListTeamDailyTasksData, ListTeamDailyTasksResponses, ListTeamParticipantsData, ListTeamParticipantsResponses, ListTeamsData, ListTeamsResponses, ListTemplateContentsData, ListTemplateContentsResponses, ListTemplatesData, ListTemplatesResponses, ListTracksData, ListTracksResponses, ListTypicalDayEventsData, ListTypicalDayEventsResponses, ListTypicalDayEventsWithActivityData, ListTypicalDayEventsWithActivityResponses, ListUserDiplomasData, ListUserDiplomasResponses, MyDailyTasksData, MyDailyTasksResponses, PatchActivityCategoryData, PatchActivityCategoryResponses, PatchActivityData, PatchActivityResponses, PatchActivityTopicData, PatchActivityTopicResponses, PatchAdminParticipantData, PatchAdminParticipantResponses, PatchAvailabilityData, PatchAvailabilityResponses, PatchCampaignData, PatchCampaignResponses, PatchCommentData, PatchCommentResponses, PatchCommentTagData, PatchCommentTagResponses, PatchDailyTaskData, PatchDailyTaskResponses, PatchDailyTaskTeamData, PatchDailyTaskTeamResponses, PatchDiplomaData, PatchDiplomaResponses, PatchEventData, PatchEventResponses, PatchEventWithActivityData, PatchEventWithActivityResponses, PatchGestionnaireInvitationData, PatchGestionnaireInvitationResponses, PatchGestionnaireMeetingData, PatchGestionnaireMeetingResponses, PatchMyParticipationData, PatchMyParticipationResponses, PatchParticipantData, PatchParticipantOpinionData, PatchParticipantOpinionResponses, PatchParticipantResponses, PatchRoomData, PatchRoomResponses, PatchTeamCategoryData, PatchTeamCategoryResponses, PatchTeamDailyTaskData, PatchTeamDailyTaskResponses, PatchTeamData, PatchTeamResponses, PatchTemplateData, PatchTemplateResponses, PatchTrackData, PatchTrackResponses, PatchTrainerProfileData, PatchTrainerProfileResponses, PostOpinionThreadMessageData, PostOpinionThreadMessageResponses, PreviewTemplateData, PreviewTemplateResponses, ReopenOpinionThreadData, ReopenOpinionThreadResponses, RequestMeetingAnonymizationData, RequestMeetingAnonymizationResponses, ResolveOpinionThreadData, ResolveOpinionThreadResponses, RetrieveActivityCategoryData, RetrieveActivityCategoryResponses, RetrieveActivityData, RetrieveActivityResponses, RetrieveActivityTopicData, RetrieveActivityTopicResponses, RetrieveAdminParticipantData, RetrieveAdminParticipantResponses, RetrieveCampaignData, RetrieveCampaignResponses, RetrieveCommentData, RetrieveCommentResponses, RetrieveCommentTagData, RetrieveCommentTagResponses, RetrieveDailyTaskData, RetrieveDailyTaskResponses, RetrieveDailyTaskTeamData, RetrieveDailyTaskTeamResponses, RetrieveEventData, RetrieveEventResponses, RetrieveEventWithActivityData, RetrieveEventWithActivityResponses, RetrieveForTeamData, RetrieveForTeamResponses, RetrieveGestionnaireInvitationData, RetrieveGestionnaireInvitationResponses, RetrieveGestionnaireMeetingData, RetrieveGestionnaireMeetingResponses, RetrieveMeData, RetrieveMeetingAccessRightsData, RetrieveMeetingAccessRightsResponses, RetrieveMeetingData, RetrieveMeetingModuleData, RetrieveMeetingModuleResponses, RetrieveMeetingResponses, RetrieveMeetingRoleData, RetrieveMeetingRoleResponses, RetrieveMeetingTagadaCandidateData, RetrieveMeetingTagadaCandidateResponses, RetrieveMeetingTypeData, RetrieveMeetingTypeResponses, RetrieveMeResponses, RetrieveMyEnrollmentData, RetrieveMyEnrollmentResponses, RetrieveMyParticipationData, RetrieveMyParticipationResponses, RetrieveParticipantData, RetrieveParticipantOpinionData, RetrieveParticipantOpinionResponses, RetrieveParticipantResponses, RetrievePlaceData, RetrievePlaceResponses, RetrievePublicMeetingData, RetrievePublicMeetingResponses, RetrieveRoomData, RetrieveRoomResponses, RetrieveTeamCategoryData, RetrieveTeamCategoryResponses, RetrieveTeamDailyTaskData, RetrieveTeamDailyTaskResponses, RetrieveTeamData, RetrieveTeamResponses, RetrieveTemplateData, RetrieveTemplateResponses, RetrieveTrackData, RetrieveTrackResponses, RetrieveUserAccessRightsData, RetrieveUserAccessRightsResponses, ScheduleTemplateData, ScheduleTemplateResponses, SendTemplateData, SendTemplateResponses, SendTestTemplateData, SendTestTemplateResponses, SetDailyTaskTeamParticipantsData, SetDailyTaskTeamParticipantsResponses, SetTeamParticipantsData, SetTeamParticipantsResponses, SyncMeetingAvisTagadaData, SyncMeetingAvisTagadaResponses, SyncMeetingFromIntranetData, SyncMeetingFromIntranetResponses, SyncMeetingParticipantsTagadaData, SyncMeetingParticipantsTagadaResponses, ToggleMeetingModuleData, ToggleMeetingModuleResponses, UpdateActivityCategoryData, UpdateActivityCategoryResponses, UpdateActivityData, UpdateActivityResponses, UpdateActivityTopicData, UpdateActivityTopicResponses, UpdateCallData, UpdateCallResponses, UpdateCampaignData, UpdateCampaignResponses, UpdateCommentData, UpdateCommentResponses, UpdateCommentTagData, UpdateCommentTagResponses, UpdateDailyTaskData, UpdateDailyTaskResponses, UpdateDailyTaskTeamData, UpdateDailyTaskTeamResponses, UpdateEventData, UpdateEventResponses, UpdateEventWithActivityData, UpdateEventWithActivityResponses, UpdateParticipantData, UpdateParticipantOpinionData, UpdateParticipantOpinionResponses, UpdateParticipantResponses, UpdateRoomData, UpdateRoomResponses, UpdateTeamCategoryData, UpdateTeamCategoryResponses, UpdateTeamDailyTaskData, UpdateTeamDailyTaskResponses, UpdateTeamData, UpdateTeamResponses, UpdateTemplateData, UpdateTemplateResponses, UpdateTrackData, UpdateTrackResponses, UpdateTrainerProfileData, UpdateTrainerProfileResponses, ValidateDeontologieData, ValidateDeontologieResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List Meetings
 *
 * List the meetings the current user participates in.
 */
export const listMeetings = <ThrowOnError extends boolean = false>(options?: Options<ListMeetingsData, ThrowOnError>): RequestResult<ListMeetingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMeetingsResponses, unknown, ThrowOnError>({
    responseTransformer: listMeetingsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/',
    ...options
});

/**
 * Retrieve Meeting
 */
export const retrieveMeeting = <ThrowOnError extends boolean = false>(options: Options<RetrieveMeetingData, ThrowOnError>): RequestResult<RetrieveMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveMeetingResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveMeetingResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{id}/',
    ...options
});

/**
 * Sync Meeting From Intranet
 */
export const syncMeetingFromIntranet = <ThrowOnError extends boolean = false>(options: Options<SyncMeetingFromIntranetData, ThrowOnError>): RequestResult<SyncMeetingFromIntranetResponses, unknown, ThrowOnError> => (options.client ?? client).post<SyncMeetingFromIntranetResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{id}/sync-from-intranet/',
    ...options
});

/**
 * Sync Meeting Participants Tagada
 */
export const syncMeetingParticipantsTagada = <ThrowOnError extends boolean = false>(options: Options<SyncMeetingParticipantsTagadaData, ThrowOnError>): RequestResult<SyncMeetingParticipantsTagadaResponses, unknown, ThrowOnError> => (options.client ?? client).post<SyncMeetingParticipantsTagadaResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{id}/sync-participants-tagada/',
    ...options
});

/**
 * Sync Meeting Avis Tagada
 */
export const syncMeetingAvisTagada = <ThrowOnError extends boolean = false>(options: Options<SyncMeetingAvisTagadaData, ThrowOnError>): RequestResult<SyncMeetingAvisTagadaResponses, unknown, ThrowOnError> => (options.client ?? client).post<SyncMeetingAvisTagadaResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{id}/sync-avis-tagada/',
    ...options
});

/**
 * Retrieve Meeting Tagada Candidate
 *
 * Look up a BAFA/BAFD candidate on Tagada by dossier number.
 */
export const retrieveMeetingTagadaCandidate = <ThrowOnError extends boolean = false>(options: Options<RetrieveMeetingTagadaCandidateData, ThrowOnError>): RequestResult<RetrieveMeetingTagadaCandidateResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveMeetingTagadaCandidateResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{id}/retrieve-tagada-candidate/',
    ...options
});

/**
 * Request Meeting Anonymization
 */
export const requestMeetingAnonymization = <ThrowOnError extends boolean = false>(options: Options<RequestMeetingAnonymizationData, ThrowOnError>): RequestResult<RequestMeetingAnonymizationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<RequestMeetingAnonymizationResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{id}/request-anonymization/',
    ...options
});

/**
 * Retrieve My Participation
 */
export const retrieveMyParticipation = <ThrowOnError extends boolean = false>(options: Options<RetrieveMyParticipationData, ThrowOnError>): RequestResult<RetrieveMyParticipationResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveMyParticipationResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveMyParticipationResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{id}/my-participation/',
    ...options
});

/**
 * Patch My Participation
 */
export const patchMyParticipation = <ThrowOnError extends boolean = false>(options: Options<PatchMyParticipationData, ThrowOnError>): RequestResult<PatchMyParticipationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchMyParticipationResponses, unknown, ThrowOnError>({
    responseTransformer: patchMyParticipationResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{id}/my-participation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Public Meetings
 */
export const listPublicMeetings = <ThrowOnError extends boolean = false>(options?: Options<ListPublicMeetingsData, ThrowOnError>): RequestResult<ListPublicMeetingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPublicMeetingsResponses, unknown, ThrowOnError>({
    responseTransformer: listPublicMeetingsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings-public/',
    ...options
});

/**
 * Retrieve Public Meeting
 */
export const retrievePublicMeeting = <ThrowOnError extends boolean = false>(options: Options<RetrievePublicMeetingData, ThrowOnError>): RequestResult<RetrievePublicMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrievePublicMeetingResponses, unknown, ThrowOnError>({
    responseTransformer: retrievePublicMeetingResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings-public/{id}/',
    ...options
});

/**
 * Retrieve Meeting Access Rights
 */
export const retrieveMeetingAccessRights = <ThrowOnError extends boolean = false>(options: Options<RetrieveMeetingAccessRightsData, ThrowOnError>): RequestResult<RetrieveMeetingAccessRightsResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveMeetingAccessRightsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings-public/{id}/access-rights/',
    ...options
});

/**
 * List Gestionnaire Meetings
 *
 * List every meeting (requires the ``view_all_meeting`` static perm).
 */
export const listGestionnaireMeetings = <ThrowOnError extends boolean = false>(options?: Options<ListGestionnaireMeetingsData, ThrowOnError>): RequestResult<ListGestionnaireMeetingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListGestionnaireMeetingsResponses, unknown, ThrowOnError>({
    responseTransformer: listGestionnaireMeetingsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/',
    ...options
});

/**
 * List Gestionnaire Meetings My Scope
 *
 * List meetings organised/managed by the user's structures.
 */
export const listGestionnaireMeetingsMyScope = <ThrowOnError extends boolean = false>(options?: Options<ListGestionnaireMeetingsMyScopeData, ThrowOnError>): RequestResult<ListGestionnaireMeetingsMyScopeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListGestionnaireMeetingsMyScopeResponses, unknown, ThrowOnError>({
    responseTransformer: listGestionnaireMeetingsMyScopeResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/my-scope-list/',
    ...options
});

/**
 * List Gestionnaire Meetings Ongoing
 *
 * Stages « en cours » pour la frise admin (lecture seule).
 *
 * Droits alignés sur les vues gestionnaire : ``view_all_meeting`` → tous les
 * stages ; ``view_scope_meeting`` → ceux des structures de l'utilisateur.
 * Renvoie les stages dont la période chevauche la fenêtre
 * ``[aujourd'hui - days, aujourd'hui + days]`` (``days=7`` par défaut,
 * ``0`` = uniquement ceux du jour). Liste non paginée : l'ensemble est borné
 * par la fenêtre et la frise a besoin de tout afficher d'un coup.
 */
export const listGestionnaireMeetingsOngoing = <ThrowOnError extends boolean = false>(options?: Options<ListGestionnaireMeetingsOngoingData, ThrowOnError>): RequestResult<ListGestionnaireMeetingsOngoingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListGestionnaireMeetingsOngoingResponses, unknown, ThrowOnError>({
    responseTransformer: listGestionnaireMeetingsOngoingResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/ongoing/',
    ...options
});

/**
 * Retrieve Gestionnaire Meeting
 */
export const retrieveGestionnaireMeeting = <ThrowOnError extends boolean = false>(options: Options<RetrieveGestionnaireMeetingData, ThrowOnError>): RequestResult<RetrieveGestionnaireMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveGestionnaireMeetingResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveGestionnaireMeetingResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/{id}/',
    ...options
});

/**
 * Patch Gestionnaire Meeting
 */
export const patchGestionnaireMeeting = <ThrowOnError extends boolean = false>(options: Options<PatchGestionnaireMeetingData, ThrowOnError>): RequestResult<PatchGestionnaireMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchGestionnaireMeetingResponses, unknown, ThrowOnError>({
    responseTransformer: patchGestionnaireMeetingResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/{id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve Gestionnaire Invitation
 */
export const retrieveGestionnaireInvitation = <ThrowOnError extends boolean = false>(options: Options<RetrieveGestionnaireInvitationData, ThrowOnError>): RequestResult<RetrieveGestionnaireInvitationResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveGestionnaireInvitationResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveGestionnaireInvitationResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/{id}/invitation/',
    ...options
});

/**
 * Patch Gestionnaire Invitation
 */
export const patchGestionnaireInvitation = <ThrowOnError extends boolean = false>(options: Options<PatchGestionnaireInvitationData, ThrowOnError>): RequestResult<PatchGestionnaireInvitationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchGestionnaireInvitationResponses, unknown, ThrowOnError>({
    responseTransformer: patchGestionnaireInvitationResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/{id}/invitation/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Gestionnaire Sync Meeting From Intranet
 */
export const gestionnaireSyncMeetingFromIntranet = <ThrowOnError extends boolean = false>(options: Options<GestionnaireSyncMeetingFromIntranetData, ThrowOnError>): RequestResult<GestionnaireSyncMeetingFromIntranetResponses, unknown, ThrowOnError> => (options.client ?? client).post<GestionnaireSyncMeetingFromIntranetResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/{id}/sync-from-intranet/',
    ...options
});

/**
 * Gestionnaire Request Meeting Anonymization
 */
export const gestionnaireRequestMeetingAnonymization = <ThrowOnError extends boolean = false>(options: Options<GestionnaireRequestMeetingAnonymizationData, ThrowOnError>): RequestResult<GestionnaireRequestMeetingAnonymizationResponses, unknown, ThrowOnError> => (options.client ?? client).patch<GestionnaireRequestMeetingAnonymizationResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-meetings/{id}/request-anonymization/',
    ...options
});

/**
 * List Admin Participants
 */
export const listAdminParticipants = <ThrowOnError extends boolean = false>(options?: Options<ListAdminParticipantsData, ThrowOnError>): RequestResult<ListAdminParticipantsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAdminParticipantsResponses, unknown, ThrowOnError>({
    responseTransformer: listAdminParticipantsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-participants/',
    ...options
});

/**
 * Retrieve Admin Participant
 */
export const retrieveAdminParticipant = <ThrowOnError extends boolean = false>(options: Options<RetrieveAdminParticipantData, ThrowOnError>): RequestResult<RetrieveAdminParticipantResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveAdminParticipantResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveAdminParticipantResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-participants/{participant_id}/',
    ...options
});

/**
 * Patch Admin Participant
 */
export const patchAdminParticipant = <ThrowOnError extends boolean = false>(options: Options<PatchAdminParticipantData, ThrowOnError>): RequestResult<PatchAdminParticipantResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchAdminParticipantResponses, unknown, ThrowOnError>({
    responseTransformer: patchAdminParticipantResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/gestionnaire-participants/{participant_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Places
 */
export const listPlaces = <ThrowOnError extends boolean = false>(options?: Options<ListPlacesData, ThrowOnError>): RequestResult<ListPlacesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPlacesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/places/',
    ...options
});

/**
 * Retrieve Place
 */
export const retrievePlace = <ThrowOnError extends boolean = false>(options: Options<RetrievePlaceData, ThrowOnError>): RequestResult<RetrievePlaceResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrievePlaceResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/places/{place_id}/',
    ...options
});

/**
 * List Meeting Types
 */
export const listMeetingTypes = <ThrowOnError extends boolean = false>(options?: Options<ListMeetingTypesData, ThrowOnError>): RequestResult<ListMeetingTypesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMeetingTypesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meeting-types/',
    ...options
});

/**
 * Retrieve Meeting Type
 */
export const retrieveMeetingType = <ThrowOnError extends boolean = false>(options: Options<RetrieveMeetingTypeData, ThrowOnError>): RequestResult<RetrieveMeetingTypeResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveMeetingTypeResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meeting-types/{type_id}/',
    ...options
});

/**
 * List Meeting Roles
 */
export const listMeetingRoles = <ThrowOnError extends boolean = false>(options?: Options<ListMeetingRolesData, ThrowOnError>): RequestResult<ListMeetingRolesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMeetingRolesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meeting-roles/',
    ...options
});

/**
 * Retrieve Meeting Role
 */
export const retrieveMeetingRole = <ThrowOnError extends boolean = false>(options: Options<RetrieveMeetingRoleData, ThrowOnError>): RequestResult<RetrieveMeetingRoleResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveMeetingRoleResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meeting-roles/{role_id}/',
    ...options
});

/**
 * List Meeting Modules
 */
export const listMeetingModules = <ThrowOnError extends boolean = false>(options?: Options<ListMeetingModulesData, ThrowOnError>): RequestResult<ListMeetingModulesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMeetingModulesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meeting-modules/',
    ...options
});

/**
 * Retrieve Meeting Module
 */
export const retrieveMeetingModule = <ThrowOnError extends boolean = false>(options: Options<RetrieveMeetingModuleData, ThrowOnError>): RequestResult<RetrieveMeetingModuleResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveMeetingModuleResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meeting-modules/{module_id}/',
    ...options
});

/**
 * List Organisatrice Structures
 *
 * Liste les structures organisatrices de stage (pour des listes déroulantes).
 */
export const listOrganisatriceStructures = <ThrowOnError extends boolean = false>(options?: Options<ListOrganisatriceStructuresData, ThrowOnError>): RequestResult<ListOrganisatriceStructuresResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListOrganisatriceStructuresResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/structures/organisatrice/',
    ...options
});

/**
 * List Centres Ressource
 *
 * Liste les centres de ressources (pour des listes déroulantes).
 */
export const listCentresRessource = <ThrowOnError extends boolean = false>(options?: Options<ListCentresRessourceData, ThrowOnError>): RequestResult<ListCentresRessourceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListCentresRessourceResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/structures/centres-ressource/',
    ...options
});

/**
 * Get Invitation
 */
export const getInvitation = <ThrowOnError extends boolean = false>(options: Options<GetInvitationData, ThrowOnError>): RequestResult<GetInvitationResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetInvitationResponses, unknown, ThrowOnError>({
    responseTransformer: getInvitationResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/invitations/{token}/',
    ...options
});

/**
 * Join Invitation
 */
export const joinInvitation = <ThrowOnError extends boolean = false>(options: Options<JoinInvitationData, ThrowOnError>): RequestResult<JoinInvitationResponses, unknown, ThrowOnError> => (options.client ?? client).post<JoinInvitationResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/invitations/{token}/join/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve Me
 *
 * L'utilisateur connecté (sans impersonation, comme la v1).
 */
export const retrieveMe = <ThrowOnError extends boolean = false>(options?: Options<RetrieveMeData, ThrowOnError>): RequestResult<RetrieveMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RetrieveMeResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveMeResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/me/',
    ...options
});

/**
 * Retrieve User Access Rights
 *
 * Droits de l'utilisateur courant hors stage (fonctions sur tous les objets).
 */
export const retrieveUserAccessRights = <ThrowOnError extends boolean = false>(options?: Options<RetrieveUserAccessRightsData, ThrowOnError>): RequestResult<RetrieveUserAccessRightsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RetrieveUserAccessRightsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/access-rights/',
    ...options
});

/**
 * Validate Deontologie
 *
 * L'utilisateur connecté accepte la charte de déontologie du formateur.
 */
export const validateDeontologie = <ThrowOnError extends boolean = false>(options?: Options<ValidateDeontologieData, ThrowOnError>): RequestResult<ValidateDeontologieResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ValidateDeontologieResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/me/deontologie/',
    ...options
});

/**
 * List Tracks
 */
export const listTracks = <ThrowOnError extends boolean = false>(options: Options<ListTracksData, ThrowOnError>): RequestResult<ListTracksResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTracksResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/tracks/',
    ...options
});

/**
 * Create Track
 */
export const createTrack = <ThrowOnError extends boolean = false>(options: Options<CreateTrackData, ThrowOnError>): RequestResult<CreateTrackResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateTrackResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/tracks/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Track
 */
export const destroyTrack = <ThrowOnError extends boolean = false>(options: Options<DestroyTrackData, ThrowOnError>): RequestResult<DestroyTrackResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyTrackResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/tracks/{track_id}/',
    ...options
});

/**
 * Retrieve Track
 */
export const retrieveTrack = <ThrowOnError extends boolean = false>(options: Options<RetrieveTrackData, ThrowOnError>): RequestResult<RetrieveTrackResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveTrackResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/tracks/{track_id}/',
    ...options
});

/**
 * Patch Track
 *
 * Tracks only have ``label``, so PATCH and PUT are equivalent; we
 * duplicate the handler to keep operationIds clean per HTTP verb.
 */
export const patchTrack = <ThrowOnError extends boolean = false>(options: Options<PatchTrackData, ThrowOnError>): RequestResult<PatchTrackResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchTrackResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/tracks/{track_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Track
 */
export const updateTrack = <ThrowOnError extends boolean = false>(options: Options<UpdateTrackData, ThrowOnError>): RequestResult<UpdateTrackResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateTrackResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/tracks/{track_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Toggle Meeting Module
 *
 * Active le module sur le stage s'il ne l'est pas, le désactive sinon.
 *
 * La v1 ne contrôlait que l'authentification : on exige ici le droit de
 * modifier le stage, et un module ``hidden`` reste réservé aux superusers
 * (c'est la règle affichée par ``sgdf-module-list``).
 */
export const toggleMeetingModule = <ThrowOnError extends boolean = false>(options: Options<ToggleMeetingModuleData, ThrowOnError>): RequestResult<ToggleMeetingModuleResponses, unknown, ThrowOnError> => (options.client ?? client).post<ToggleMeetingModuleResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/modules/{module_id}/toggle/',
    ...options
});

/**
 * List Rooms
 */
export const listRooms = <ThrowOnError extends boolean = false>(options: Options<ListRoomsData, ThrowOnError>): RequestResult<ListRoomsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListRoomsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/rooms/',
    ...options
});

/**
 * Create Room
 */
export const createRoom = <ThrowOnError extends boolean = false>(options: Options<CreateRoomData, ThrowOnError>): RequestResult<CreateRoomResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateRoomResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/rooms/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Room
 */
export const destroyRoom = <ThrowOnError extends boolean = false>(options: Options<DestroyRoomData, ThrowOnError>): RequestResult<DestroyRoomResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyRoomResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/rooms/{room_id}/',
    ...options
});

/**
 * Retrieve Room
 */
export const retrieveRoom = <ThrowOnError extends boolean = false>(options: Options<RetrieveRoomData, ThrowOnError>): RequestResult<RetrieveRoomResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveRoomResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/rooms/{room_id}/',
    ...options
});

/**
 * Patch Room
 */
export const patchRoom = <ThrowOnError extends boolean = false>(options: Options<PatchRoomData, ThrowOnError>): RequestResult<PatchRoomResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchRoomResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/rooms/{room_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Room
 */
export const updateRoom = <ThrowOnError extends boolean = false>(options: Options<UpdateRoomData, ThrowOnError>): RequestResult<UpdateRoomResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateRoomResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/rooms/{room_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Campaigns
 */
export const listCampaigns = <ThrowOnError extends boolean = false>(options: Options<ListCampaignsData, ThrowOnError>): RequestResult<ListCampaignsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListCampaignsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/',
    ...options
});

/**
 * Create Campaign
 */
export const createCampaign = <ThrowOnError extends boolean = false>(options: Options<CreateCampaignData, ThrowOnError>): RequestResult<CreateCampaignResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateCampaignResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve Campaign
 */
export const retrieveCampaign = <ThrowOnError extends boolean = false>(options: Options<RetrieveCampaignData, ThrowOnError>): RequestResult<RetrieveCampaignResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveCampaignResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/',
    ...options
});

/**
 * Patch Campaign
 */
export const patchCampaign = <ThrowOnError extends boolean = false>(options: Options<PatchCampaignData, ThrowOnError>): RequestResult<PatchCampaignResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchCampaignResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Campaign
 */
export const updateCampaign = <ThrowOnError extends boolean = false>(options: Options<UpdateCampaignData, ThrowOnError>): RequestResult<UpdateCampaignResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateCampaignResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Templates
 */
export const listTemplates = <ThrowOnError extends boolean = false>(options: Options<ListTemplatesData, ThrowOnError>): RequestResult<ListTemplatesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTemplatesResponses, unknown, ThrowOnError>({
    responseTransformer: listTemplatesResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/',
    ...options
});

/**
 * Create Template
 */
export const createTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateTemplateData, ThrowOnError>): RequestResult<CreateTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateTemplateResponses, unknown, ThrowOnError>({
    responseTransformer: createTemplateResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Template
 */
export const destroyTemplate = <ThrowOnError extends boolean = false>(options: Options<DestroyTemplateData, ThrowOnError>): RequestResult<DestroyTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyTemplateResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/',
    ...options
});

/**
 * Retrieve Template
 */
export const retrieveTemplate = <ThrowOnError extends boolean = false>(options: Options<RetrieveTemplateData, ThrowOnError>): RequestResult<RetrieveTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveTemplateResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveTemplateResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/',
    ...options
});

/**
 * Patch Template
 */
export const patchTemplate = <ThrowOnError extends boolean = false>(options: Options<PatchTemplateData, ThrowOnError>): RequestResult<PatchTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchTemplateResponses, unknown, ThrowOnError>({
    responseTransformer: patchTemplateResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Template
 */
export const updateTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateTemplateData, ThrowOnError>): RequestResult<UpdateTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateTemplateResponses, unknown, ThrowOnError>({
    responseTransformer: updateTemplateResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Template
 */
export const sendTemplate = <ThrowOnError extends boolean = false>(options: Options<SendTemplateData, ThrowOnError>): RequestResult<SendTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).post<SendTemplateResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/send/',
    ...options
});

/**
 * Preview Template
 *
 * Aperçu du mail (brouillon éventuel dans le body) pour le premier
 * destinataire ciblé. Ne modifie rien.
 */
export const previewTemplate = <ThrowOnError extends boolean = false>(options: Options<PreviewTemplateData, ThrowOnError>): RequestResult<PreviewTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).post<PreviewTemplateResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/preview/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Test Template
 *
 * Envoie le message (brouillon éventuel dans le body) à l'utilisateur
 * connecté uniquement, sans suivi ni marquage d'envoi.
 */
export const sendTestTemplate = <ThrowOnError extends boolean = false>(options: Options<SendTestTemplateData, ThrowOnError>): RequestResult<SendTestTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).post<SendTestTemplateResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/send-test/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Template Contents
 *
 * Suivi par destinataire (statut ESP, ouvertures) : en cas de renvoi, seul
 * le **dernier** message de chaque destinataire est retourné.
 */
export const listTemplateContents = <ThrowOnError extends boolean = false>(options: Options<ListTemplateContentsData, ThrowOnError>): RequestResult<ListTemplateContentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTemplateContentsResponses, unknown, ThrowOnError>({
    responseTransformer: listTemplateContentsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/contents/',
    ...options
});

/**
 * Schedule Template
 *
 * Programme (ou annule si ``scheduled_at`` est null) l'envoi du template.
 * L'envoi effectif est fait par la tâche celery ``process_scheduled_communications``.
 */
export const scheduleTemplate = <ThrowOnError extends boolean = false>(options: Options<ScheduleTemplateData, ThrowOnError>): RequestResult<ScheduleTemplateResponses, unknown, ThrowOnError> => (options.client ?? client).post<ScheduleTemplateResponses, unknown, ThrowOnError>({
    responseTransformer: scheduleTemplateResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/info-campaign/{campaign_id}/templates/{template_id}/schedule/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Comment Tags
 */
export const listCommentTags = <ThrowOnError extends boolean = false>(options: Options<ListCommentTagsData, ThrowOnError>): RequestResult<ListCommentTagsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListCommentTagsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/comment-tags/',
    ...options
});

/**
 * Create Comment Tag
 */
export const createCommentTag = <ThrowOnError extends boolean = false>(options: Options<CreateCommentTagData, ThrowOnError>): RequestResult<CreateCommentTagResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateCommentTagResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/comment-tags/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Comment Tag
 */
export const destroyCommentTag = <ThrowOnError extends boolean = false>(options: Options<DestroyCommentTagData, ThrowOnError>): RequestResult<DestroyCommentTagResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyCommentTagResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/comment-tags/{tag_id}/',
    ...options
});

/**
 * Retrieve Comment Tag
 */
export const retrieveCommentTag = <ThrowOnError extends boolean = false>(options: Options<RetrieveCommentTagData, ThrowOnError>): RequestResult<RetrieveCommentTagResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveCommentTagResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/comment-tags/{tag_id}/',
    ...options
});

/**
 * Patch Comment Tag
 */
export const patchCommentTag = <ThrowOnError extends boolean = false>(options: Options<PatchCommentTagData, ThrowOnError>): RequestResult<PatchCommentTagResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchCommentTagResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/comment-tags/{tag_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Comment Tag
 */
export const updateCommentTag = <ThrowOnError extends boolean = false>(options: Options<UpdateCommentTagData, ThrowOnError>): RequestResult<UpdateCommentTagResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateCommentTagResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/comment-tags/{tag_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Participants
 */
export const listParticipants = <ThrowOnError extends boolean = false>(options: Options<ListParticipantsData, ThrowOnError>): RequestResult<ListParticipantsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListParticipantsResponses, unknown, ThrowOnError>({
    responseTransformer: listParticipantsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/',
    ...options
});

/**
 * List Participant Opinions
 */
export const listParticipantOpinions = <ThrowOnError extends boolean = false>(options: Options<ListParticipantOpinionsData, ThrowOnError>): RequestResult<ListParticipantOpinionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListParticipantOpinionsResponses, unknown, ThrowOnError>({
    responseTransformer: listParticipantOpinionsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/opinion-list/',
    ...options
});

/**
 * Retrieve Participant
 */
export const retrieveParticipant = <ThrowOnError extends boolean = false>(options: Options<RetrieveParticipantData, ThrowOnError>): RequestResult<RetrieveParticipantResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveParticipantResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveParticipantResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/',
    ...options
});

/**
 * Patch Participant
 */
export const patchParticipant = <ThrowOnError extends boolean = false>(options: Options<PatchParticipantData, ThrowOnError>): RequestResult<PatchParticipantResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchParticipantResponses, unknown, ThrowOnError>({
    responseTransformer: patchParticipantResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Participant
 */
export const updateParticipant = <ThrowOnError extends boolean = false>(options: Options<UpdateParticipantData, ThrowOnError>): RequestResult<UpdateParticipantResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateParticipantResponses, unknown, ThrowOnError>({
    responseTransformer: updateParticipantResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retrieve Participant Opinion
 */
export const retrieveParticipantOpinion = <ThrowOnError extends boolean = false>(options: Options<RetrieveParticipantOpinionData, ThrowOnError>): RequestResult<RetrieveParticipantOpinionResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveParticipantOpinionResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveParticipantOpinionResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/opinion/',
    ...options
});

/**
 * Patch Participant Opinion
 */
export const patchParticipantOpinion = <ThrowOnError extends boolean = false>(options: Options<PatchParticipantOpinionData, ThrowOnError>): RequestResult<PatchParticipantOpinionResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchParticipantOpinionResponses, unknown, ThrowOnError>({
    responseTransformer: patchParticipantOpinionResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/opinion/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Participant Opinion
 */
export const updateParticipantOpinion = <ThrowOnError extends boolean = false>(options: Options<UpdateParticipantOpinionData, ThrowOnError>): RequestResult<UpdateParticipantOpinionResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateParticipantOpinionResponses, unknown, ThrowOnError>({
    responseTransformer: updateParticipantOpinionResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/opinion/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Comments
 */
export const listComments = <ThrowOnError extends boolean = false>(options: Options<ListCommentsData, ThrowOnError>): RequestResult<ListCommentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListCommentsResponses, unknown, ThrowOnError>({
    responseTransformer: listCommentsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/comments/',
    ...options
});

/**
 * Create Comment
 */
export const createComment = <ThrowOnError extends boolean = false>(options: Options<CreateCommentData, ThrowOnError>): RequestResult<CreateCommentResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateCommentResponses, unknown, ThrowOnError>({
    responseTransformer: createCommentResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/comments/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Comment
 */
export const destroyComment = <ThrowOnError extends boolean = false>(options: Options<DestroyCommentData, ThrowOnError>): RequestResult<DestroyCommentResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyCommentResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/comments/{comment_id}/',
    ...options
});

/**
 * Retrieve Comment
 */
export const retrieveComment = <ThrowOnError extends boolean = false>(options: Options<RetrieveCommentData, ThrowOnError>): RequestResult<RetrieveCommentResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveCommentResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveCommentResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/comments/{comment_id}/',
    ...options
});

/**
 * Patch Comment
 */
export const patchComment = <ThrowOnError extends boolean = false>(options: Options<PatchCommentData, ThrowOnError>): RequestResult<PatchCommentResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchCommentResponses, unknown, ThrowOnError>({
    responseTransformer: patchCommentResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/comments/{comment_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Comment
 */
export const updateComment = <ThrowOnError extends boolean = false>(options: Options<UpdateCommentData, ThrowOnError>): RequestResult<UpdateCommentResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateCommentResponses, unknown, ThrowOnError>({
    responseTransformer: updateCommentResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/comments/{comment_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Opinion Thread
 */
export const getOpinionThread = <ThrowOnError extends boolean = false>(options: Options<GetOpinionThreadData, ThrowOnError>): RequestResult<GetOpinionThreadResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetOpinionThreadResponses, unknown, ThrowOnError>({
    responseTransformer: getOpinionThreadResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/opinion-thread/',
    ...options
});

/**
 * Post Opinion Thread Message
 */
export const postOpinionThreadMessage = <ThrowOnError extends boolean = false>(options: Options<PostOpinionThreadMessageData, ThrowOnError>): RequestResult<PostOpinionThreadMessageResponses, unknown, ThrowOnError> => (options.client ?? client).post<PostOpinionThreadMessageResponses, unknown, ThrowOnError>({
    responseTransformer: postOpinionThreadMessageResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/opinion-thread/messages/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve Opinion Thread
 */
export const resolveOpinionThread = <ThrowOnError extends boolean = false>(options: Options<ResolveOpinionThreadData, ThrowOnError>): RequestResult<ResolveOpinionThreadResponses, unknown, ThrowOnError> => (options.client ?? client).post<ResolveOpinionThreadResponses, unknown, ThrowOnError>({
    responseTransformer: resolveOpinionThreadResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/opinion-thread/resolve/',
    ...options
});

/**
 * Reopen Opinion Thread
 */
export const reopenOpinionThread = <ThrowOnError extends boolean = false>(options: Options<ReopenOpinionThreadData, ThrowOnError>): RequestResult<ReopenOpinionThreadResponses, unknown, ThrowOnError> => (options.client ?? client).post<ReopenOpinionThreadResponses, unknown, ThrowOnError>({
    responseTransformer: reopenOpinionThreadResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/participants/{participant_id}/opinion-thread/reopen/',
    ...options
});

/**
 * List Public Events
 *
 * Planning of a participant, public attributes only.
 */
export const listPublicEvents = <ThrowOnError extends boolean = false>(options: Options<ListPublicEventsData, ThrowOnError>): RequestResult<ListPublicEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListPublicEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listPublicEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/public-list/',
    ...options
});

/**
 * List Planning Events
 */
export const listPlanningEvents = <ThrowOnError extends boolean = false>(options: Options<ListPlanningEventsData, ThrowOnError>): RequestResult<ListPlanningEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListPlanningEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listPlanningEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/planning/',
    ...options
});

/**
 * List Own Planning Events
 *
 * Events the participant is responsible for (supervisor or team in charge).
 */
export const listOwnPlanningEvents = <ThrowOnError extends boolean = false>(options: Options<ListOwnPlanningEventsData, ThrowOnError>): RequestResult<ListOwnPlanningEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListOwnPlanningEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listOwnPlanningEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/own-planning/',
    ...options
});

/**
 * List My Daily Events
 *
 * Upcoming events of the participant's planning.
 *
 * v1 also forced ``limit=10``, which its page-number paginator ignored
 * (``page_size_query_param`` is ``page_size``), so it never capped anything.
 */
export const listMyDailyEvents = <ThrowOnError extends boolean = false>(options: Options<ListMyDailyEventsData, ThrowOnError>): RequestResult<ListMyDailyEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListMyDailyEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listMyDailyEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/my-daily-events/',
    ...options
});

/**
 * List Supervisor Events
 */
export const listSupervisorEvents = <ThrowOnError extends boolean = false>(options: Options<ListSupervisorEventsData, ThrowOnError>): RequestResult<ListSupervisorEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListSupervisorEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listSupervisorEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/supervisor/',
    ...options
});

/**
 * List In Charge Events
 */
export const listInChargeEvents = <ThrowOnError extends boolean = false>(options: Options<ListInChargeEventsData, ThrowOnError>): RequestResult<ListInChargeEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListInChargeEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listInChargeEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/in-charge/',
    ...options
});

/**
 * List Typical Day Events
 */
export const listTypicalDayEvents = <ThrowOnError extends boolean = false>(options: Options<ListTypicalDayEventsData, ThrowOnError>): RequestResult<ListTypicalDayEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTypicalDayEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listTypicalDayEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/typical-day/',
    ...options
});

/**
 * List Modular Events
 *
 * MODULAIRE parents with their children fully detailed.
 */
export const listModularEvents = <ThrowOnError extends boolean = false>(options: Options<ListModularEventsData, ThrowOnError>): RequestResult<ListModularEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListModularEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listModularEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/modular/',
    ...options
});

/**
 * List Public Modular Events
 *
 * MODULAIRE parents that have a published self-enrollment child.
 */
export const listPublicModularEvents = <ThrowOnError extends boolean = false>(options: Options<ListPublicModularEventsData, ThrowOnError>): RequestResult<ListPublicModularEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListPublicModularEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listPublicModularEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/public-modular/',
    ...options
});

/**
 * List Events
 *
 * Full event list with the v1 filters.
 *
 * v1 exposed the ``event_type`` filter twice (``event_type`` exact and
 * ``event_type__in``); a single repeatable ``event_type`` covers both.
 * ``only_future=false`` is a no-op here, whereas v1's ``BooleanFilter``
 * filtered for any value it received.
 */
export const listEvents = <ThrowOnError extends boolean = false>(options: Options<ListEventsData, ThrowOnError>): RequestResult<ListEventsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListEventsResponses, unknown, ThrowOnError>({
    responseTransformer: listEventsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/',
    ...options
});

/**
 * Create Event
 */
export const createEvent = <ThrowOnError extends boolean = false>(options: Options<CreateEventData, ThrowOnError>): RequestResult<CreateEventResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateEventResponses, unknown, ThrowOnError>({
    responseTransformer: createEventResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply Typical Day
 *
 * Stamp the JOURNEE_TYPE events onto the given days, and return the
 * concrete events that now sit on those days.
 */
export const applyTypicalDay = <ThrowOnError extends boolean = false>(options: Options<ApplyTypicalDayData, ThrowOnError>): RequestResult<ApplyTypicalDayResponses, unknown, ThrowOnError> => (options.client ?? client).post<ApplyTypicalDayResponses, unknown, ThrowOnError>({
    responseTransformer: applyTypicalDayResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/apply-typical-day/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Enrollments
 *
 * Current participant's enrollments across the meeting's events.
 *
 * Returns nothing when the caller has no participation: v1 dropped the
 * ``participant_id`` filter in that case and leaked every enrollment of the
 * meeting.
 */
export const listMyEnrollments = <ThrowOnError extends boolean = false>(options: Options<ListMyEnrollmentsData, ThrowOnError>): RequestResult<ListMyEnrollmentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListMyEnrollmentsResponses, unknown, ThrowOnError>({
    responseTransformer: listMyEnrollmentsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/my-enrollments/',
    ...options
});

/**
 * List Meeting Enrollments
 */
export const listMeetingEnrollments = <ThrowOnError extends boolean = false>(options: Options<ListMeetingEnrollmentsData, ThrowOnError>): RequestResult<ListMeetingEnrollmentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListMeetingEnrollmentsResponses, unknown, ThrowOnError>({
    responseTransformer: listMeetingEnrollmentsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/enrollments/',
    ...options
});

/**
 * Destroy Event
 */
export const destroyEvent = <ThrowOnError extends boolean = false>(options: Options<DestroyEventData, ThrowOnError>): RequestResult<DestroyEventResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyEventResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/',
    ...options
});

/**
 * Retrieve Event
 */
export const retrieveEvent = <ThrowOnError extends boolean = false>(options: Options<RetrieveEventData, ThrowOnError>): RequestResult<RetrieveEventResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveEventResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveEventResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/',
    ...options
});

/**
 * Patch Event
 */
export const patchEvent = <ThrowOnError extends boolean = false>(options: Options<PatchEventData, ThrowOnError>): RequestResult<PatchEventResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchEventResponses, unknown, ThrowOnError>({
    responseTransformer: patchEventResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Event
 */
export const updateEvent = <ThrowOnError extends boolean = false>(options: Options<UpdateEventData, ThrowOnError>): RequestResult<UpdateEventResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateEventResponses, unknown, ThrowOnError>({
    responseTransformer: updateEventResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Copy Event To Days
 */
export const copyEventToDays = <ThrowOnError extends boolean = false>(options: Options<CopyEventToDaysData, ThrowOnError>): RequestResult<CopyEventToDaysResponses, unknown, ThrowOnError> => (options.client ?? client).post<CopyEventToDaysResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/copy-to-days/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Event Children
 *
 * Published children of a modular parent.
 */
export const listEventChildren = <ThrowOnError extends boolean = false>(options: Options<ListEventChildrenData, ThrowOnError>): RequestResult<ListEventChildrenResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListEventChildrenResponses, unknown, ThrowOnError>({
    responseTransformer: listEventChildrenResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/children/',
    ...options
});

/**
 * Create Event Child
 */
export const createEventChild = <ThrowOnError extends boolean = false>(options: Options<CreateEventChildData, ThrowOnError>): RequestResult<CreateEventChildResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateEventChildResponses, unknown, ThrowOnError>({
    responseTransformer: createEventChildResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/children/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy My Enrollment
 */
export const destroyMyEnrollment = <ThrowOnError extends boolean = false>(options: Options<DestroyMyEnrollmentData, ThrowOnError>): RequestResult<DestroyMyEnrollmentResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyMyEnrollmentResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/my-enrollment/',
    ...options
});

/**
 * Retrieve My Enrollment
 *
 * Current participant's enrollment on this event, ``null`` if none.
 *
 * Same leak fix as :func:`list_my_enrollments`: v1 returned another
 * participant's enrollment when the caller had none.
 */
export const retrieveMyEnrollment = <ThrowOnError extends boolean = false>(options: Options<RetrieveMyEnrollmentData, ThrowOnError>): RequestResult<RetrieveMyEnrollmentResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveMyEnrollmentResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveMyEnrollmentResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/my-enrollment/',
    ...options
});

/**
 * Create My Enrollment
 *
 * Self-enrollment of the current participant.
 */
export const createMyEnrollment = <ThrowOnError extends boolean = false>(options: Options<CreateMyEnrollmentData, ThrowOnError>): RequestResult<CreateMyEnrollmentResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateMyEnrollmentResponses, unknown, ThrowOnError>({
    responseTransformer: createMyEnrollmentResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/my-enrollment/',
    ...options
});

/**
 * Destroy Event Enrollment
 *
 * Managed cancellation — ``participant_id`` is a required query param, as
 * in v1.
 */
export const destroyEventEnrollment = <ThrowOnError extends boolean = false>(options: Options<DestroyEventEnrollmentData, ThrowOnError>): RequestResult<DestroyEventEnrollmentResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyEventEnrollmentResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/enrollment/',
    ...options
});

/**
 * List Event Enrollments
 */
export const listEventEnrollments = <ThrowOnError extends boolean = false>(options: Options<ListEventEnrollmentsData, ThrowOnError>): RequestResult<ListEventEnrollmentsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListEventEnrollmentsResponses, unknown, ThrowOnError>({
    responseTransformer: listEventEnrollmentsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/enrollment/',
    ...options
});

/**
 * Create Event Enrollment
 *
 * Managed enrollment: enroll someone else on an event.
 */
export const createEventEnrollment = <ThrowOnError extends boolean = false>(options: Options<CreateEventEnrollmentData, ThrowOnError>): RequestResult<CreateEventEnrollmentResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateEventEnrollmentResponses, unknown, ThrowOnError>({
    responseTransformer: createEventEnrollmentResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events/{event_id}/enrollment/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Public Events With Activity
 */
export const listPublicEventsWithActivity = <ThrowOnError extends boolean = false>(options: Options<ListPublicEventsWithActivityData, ThrowOnError>): RequestResult<ListPublicEventsWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListPublicEventsWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: listPublicEventsWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/public-list/',
    ...options
});

/**
 * List Planning Events With Activity
 */
export const listPlanningEventsWithActivity = <ThrowOnError extends boolean = false>(options: Options<ListPlanningEventsWithActivityData, ThrowOnError>): RequestResult<ListPlanningEventsWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListPlanningEventsWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: listPlanningEventsWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/planning/',
    ...options
});

/**
 * List Own Planning Events With Activity
 */
export const listOwnPlanningEventsWithActivity = <ThrowOnError extends boolean = false>(options: Options<ListOwnPlanningEventsWithActivityData, ThrowOnError>): RequestResult<ListOwnPlanningEventsWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListOwnPlanningEventsWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: listOwnPlanningEventsWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/own-planning/',
    ...options
});

/**
 * List My Daily Events With Activity
 */
export const listMyDailyEventsWithActivity = <ThrowOnError extends boolean = false>(options: Options<ListMyDailyEventsWithActivityData, ThrowOnError>): RequestResult<ListMyDailyEventsWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListMyDailyEventsWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: listMyDailyEventsWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/my-daily-events/',
    ...options
});

/**
 * List Supervisor Events With Activity
 */
export const listSupervisorEventsWithActivity = <ThrowOnError extends boolean = false>(options: Options<ListSupervisorEventsWithActivityData, ThrowOnError>): RequestResult<ListSupervisorEventsWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListSupervisorEventsWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: listSupervisorEventsWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/supervisor/',
    ...options
});

/**
 * List In Charge Events With Activity
 */
export const listInChargeEventsWithActivity = <ThrowOnError extends boolean = false>(options: Options<ListInChargeEventsWithActivityData, ThrowOnError>): RequestResult<ListInChargeEventsWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListInChargeEventsWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: listInChargeEventsWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/in-charge/',
    ...options
});

/**
 * List Typical Day Events With Activity
 */
export const listTypicalDayEventsWithActivity = <ThrowOnError extends boolean = false>(options: Options<ListTypicalDayEventsWithActivityData, ThrowOnError>): RequestResult<ListTypicalDayEventsWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTypicalDayEventsWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: listTypicalDayEventsWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/typical-day/',
    ...options
});

/**
 * List Events With Activity
 */
export const listEventsWithActivity = <ThrowOnError extends boolean = false>(options: Options<ListEventsWithActivityData, ThrowOnError>): RequestResult<ListEventsWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListEventsWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: listEventsWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/',
    ...options
});

/**
 * Create Event With Activity
 *
 * Create the activity and the event that carries it, in one call.
 */
export const createEventWithActivity = <ThrowOnError extends boolean = false>(options: Options<CreateEventWithActivityData, ThrowOnError>): RequestResult<CreateEventWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateEventWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: createEventWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Apply Typical Day With Activity
 *
 * Same as ``/events/apply-typical-day/`` — v1 also answered with the
 * non-nested schema on this prefix.
 */
export const applyTypicalDayWithActivity = <ThrowOnError extends boolean = false>(options: Options<ApplyTypicalDayWithActivityData, ThrowOnError>): RequestResult<ApplyTypicalDayWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).post<ApplyTypicalDayWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: applyTypicalDayWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/apply-typical-day/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Event With Activity
 */
export const destroyEventWithActivity = <ThrowOnError extends boolean = false>(options: Options<DestroyEventWithActivityData, ThrowOnError>): RequestResult<DestroyEventWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyEventWithActivityResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/{event_id}/',
    ...options
});

/**
 * Retrieve Event With Activity
 */
export const retrieveEventWithActivity = <ThrowOnError extends boolean = false>(options: Options<RetrieveEventWithActivityData, ThrowOnError>): RequestResult<RetrieveEventWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveEventWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveEventWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/{event_id}/',
    ...options
});

/**
 * Patch Event With Activity
 */
export const patchEventWithActivity = <ThrowOnError extends boolean = false>(options: Options<PatchEventWithActivityData, ThrowOnError>): RequestResult<PatchEventWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchEventWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: patchEventWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/{event_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Event With Activity
 *
 * Replace the event and update its existing activity in place.
 */
export const updateEventWithActivity = <ThrowOnError extends boolean = false>(options: Options<UpdateEventWithActivityData, ThrowOnError>): RequestResult<UpdateEventWithActivityResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateEventWithActivityResponses, unknown, ThrowOnError>({
    responseTransformer: updateEventWithActivityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/events-with-activity/{event_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Activity Topics
 */
export const listActivityTopics = <ThrowOnError extends boolean = false>(options: Options<ListActivityTopicsData, ThrowOnError>): RequestResult<ListActivityTopicsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListActivityTopicsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-topics/',
    ...options
});

/**
 * Create Activity Topic
 */
export const createActivityTopic = <ThrowOnError extends boolean = false>(options: Options<CreateActivityTopicData, ThrowOnError>): RequestResult<CreateActivityTopicResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateActivityTopicResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-topics/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Activity Topic
 */
export const destroyActivityTopic = <ThrowOnError extends boolean = false>(options: Options<DestroyActivityTopicData, ThrowOnError>): RequestResult<DestroyActivityTopicResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyActivityTopicResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-topics/{topic_id}/',
    ...options
});

/**
 * Retrieve Activity Topic
 */
export const retrieveActivityTopic = <ThrowOnError extends boolean = false>(options: Options<RetrieveActivityTopicData, ThrowOnError>): RequestResult<RetrieveActivityTopicResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveActivityTopicResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-topics/{topic_id}/',
    ...options
});

/**
 * Patch Activity Topic
 */
export const patchActivityTopic = <ThrowOnError extends boolean = false>(options: Options<PatchActivityTopicData, ThrowOnError>): RequestResult<PatchActivityTopicResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchActivityTopicResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-topics/{topic_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Activity Topic
 */
export const updateActivityTopic = <ThrowOnError extends boolean = false>(options: Options<UpdateActivityTopicData, ThrowOnError>): RequestResult<UpdateActivityTopicResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateActivityTopicResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-topics/{topic_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Activity Categories
 */
export const listActivityCategories = <ThrowOnError extends boolean = false>(options: Options<ListActivityCategoriesData, ThrowOnError>): RequestResult<ListActivityCategoriesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListActivityCategoriesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-categories/',
    ...options
});

/**
 * Create Activity Category
 */
export const createActivityCategory = <ThrowOnError extends boolean = false>(options: Options<CreateActivityCategoryData, ThrowOnError>): RequestResult<CreateActivityCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateActivityCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-categories/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Activity Category
 */
export const destroyActivityCategory = <ThrowOnError extends boolean = false>(options: Options<DestroyActivityCategoryData, ThrowOnError>): RequestResult<DestroyActivityCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyActivityCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-categories/{category_id}/',
    ...options
});

/**
 * Retrieve Activity Category
 */
export const retrieveActivityCategory = <ThrowOnError extends boolean = false>(options: Options<RetrieveActivityCategoryData, ThrowOnError>): RequestResult<RetrieveActivityCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveActivityCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-categories/{category_id}/',
    ...options
});

/**
 * Patch Activity Category
 */
export const patchActivityCategory = <ThrowOnError extends boolean = false>(options: Options<PatchActivityCategoryData, ThrowOnError>): RequestResult<PatchActivityCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchActivityCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-categories/{category_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Activity Category
 */
export const updateActivityCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateActivityCategoryData, ThrowOnError>): RequestResult<UpdateActivityCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateActivityCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activity-categories/{category_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Activities
 */
export const listActivities = <ThrowOnError extends boolean = false>(options: Options<ListActivitiesData, ThrowOnError>): RequestResult<ListActivitiesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListActivitiesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activities/',
    ...options
});

/**
 * Create Activity
 */
export const createActivity = <ThrowOnError extends boolean = false>(options: Options<CreateActivityData, ThrowOnError>): RequestResult<CreateActivityResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateActivityResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activities/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Activity
 */
export const destroyActivity = <ThrowOnError extends boolean = false>(options: Options<DestroyActivityData, ThrowOnError>): RequestResult<DestroyActivityResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyActivityResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activities/{activity_id}/',
    ...options
});

/**
 * Retrieve Activity
 */
export const retrieveActivity = <ThrowOnError extends boolean = false>(options: Options<RetrieveActivityData, ThrowOnError>): RequestResult<RetrieveActivityResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveActivityResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activities/{activity_id}/',
    ...options
});

/**
 * Patch Activity
 */
export const patchActivity = <ThrowOnError extends boolean = false>(options: Options<PatchActivityData, ThrowOnError>): RequestResult<PatchActivityResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchActivityResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activities/{activity_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Activity
 */
export const updateActivity = <ThrowOnError extends boolean = false>(options: Options<UpdateActivityData, ThrowOnError>): RequestResult<UpdateActivityResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateActivityResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/activities/{activity_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Team Categories
 */
export const listTeamCategories = <ThrowOnError extends boolean = false>(options: Options<ListTeamCategoriesData, ThrowOnError>): RequestResult<ListTeamCategoriesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTeamCategoriesResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams-categories/',
    ...options
});

/**
 * Create Team Category
 */
export const createTeamCategory = <ThrowOnError extends boolean = false>(options: Options<CreateTeamCategoryData, ThrowOnError>): RequestResult<CreateTeamCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateTeamCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams-categories/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Team Category
 */
export const destroyTeamCategory = <ThrowOnError extends boolean = false>(options: Options<DestroyTeamCategoryData, ThrowOnError>): RequestResult<DestroyTeamCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyTeamCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams-categories/{category_id}/',
    ...options
});

/**
 * Retrieve Team Category
 */
export const retrieveTeamCategory = <ThrowOnError extends boolean = false>(options: Options<RetrieveTeamCategoryData, ThrowOnError>): RequestResult<RetrieveTeamCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveTeamCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams-categories/{category_id}/',
    ...options
});

/**
 * Patch Team Category
 *
 * ``TeamCategory`` only has ``label``; PATCH ≡ PUT here.
 */
export const patchTeamCategory = <ThrowOnError extends boolean = false>(options: Options<PatchTeamCategoryData, ThrowOnError>): RequestResult<PatchTeamCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchTeamCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams-categories/{category_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Team Category
 */
export const updateTeamCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateTeamCategoryData, ThrowOnError>): RequestResult<UpdateTeamCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateTeamCategoryResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams-categories/{category_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Teams
 */
export const listTeams = <ThrowOnError extends boolean = false>(options: Options<ListTeamsData, ThrowOnError>): RequestResult<ListTeamsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTeamsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams/',
    ...options
});

/**
 * Create Team
 */
export const createTeam = <ThrowOnError extends boolean = false>(options: Options<CreateTeamData, ThrowOnError>): RequestResult<CreateTeamResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Team
 */
export const destroyTeam = <ThrowOnError extends boolean = false>(options: Options<DestroyTeamData, ThrowOnError>): RequestResult<DestroyTeamResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams/{team_id}/',
    ...options
});

/**
 * Retrieve Team
 */
export const retrieveTeam = <ThrowOnError extends boolean = false>(options: Options<RetrieveTeamData, ThrowOnError>): RequestResult<RetrieveTeamResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams/{team_id}/',
    ...options
});

/**
 * Patch Team
 */
export const patchTeam = <ThrowOnError extends boolean = false>(options: Options<PatchTeamData, ThrowOnError>): RequestResult<PatchTeamResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams/{team_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Team
 */
export const updateTeam = <ThrowOnError extends boolean = false>(options: Options<UpdateTeamData, ThrowOnError>): RequestResult<UpdateTeamResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams/{team_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Team Participants
 *
 * GET equivalent of @action participants on TeamByMeetingViewSet.
 */
export const listTeamParticipants = <ThrowOnError extends boolean = false>(options: Options<ListTeamParticipantsData, ThrowOnError>): RequestResult<ListTeamParticipantsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTeamParticipantsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams/{team_id}/participants/',
    ...options
});

/**
 * Set Team Participants
 *
 * PUT replaces the team's participants. Removes each one from any
 * other team within the same category first (mirrors the DRF action).
 */
export const setTeamParticipants = <ThrowOnError extends boolean = false>(options: Options<SetTeamParticipantsData, ThrowOnError>): RequestResult<SetTeamParticipantsResponses, unknown, ThrowOnError> => (options.client ?? client).put<SetTeamParticipantsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/teams/{team_id}/participants/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Daily Task Teams
 */
export const listDailyTaskTeams = <ThrowOnError extends boolean = false>(options: Options<ListDailyTaskTeamsData, ThrowOnError>): RequestResult<ListDailyTaskTeamsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListDailyTaskTeamsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/',
    ...options
});

/**
 * Create Daily Task Team
 */
export const createDailyTaskTeam = <ThrowOnError extends boolean = false>(options: Options<CreateDailyTaskTeamData, ThrowOnError>): RequestResult<CreateDailyTaskTeamResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateDailyTaskTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Daily Task Team
 */
export const destroyDailyTaskTeam = <ThrowOnError extends boolean = false>(options: Options<DestroyDailyTaskTeamData, ThrowOnError>): RequestResult<DestroyDailyTaskTeamResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyDailyTaskTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/{team_id}/',
    ...options
});

/**
 * Retrieve Daily Task Team
 */
export const retrieveDailyTaskTeam = <ThrowOnError extends boolean = false>(options: Options<RetrieveDailyTaskTeamData, ThrowOnError>): RequestResult<RetrieveDailyTaskTeamResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveDailyTaskTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/{team_id}/',
    ...options
});

/**
 * Patch Daily Task Team
 */
export const patchDailyTaskTeam = <ThrowOnError extends boolean = false>(options: Options<PatchDailyTaskTeamData, ThrowOnError>): RequestResult<PatchDailyTaskTeamResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchDailyTaskTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/{team_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Daily Task Team
 */
export const updateDailyTaskTeam = <ThrowOnError extends boolean = false>(options: Options<UpdateDailyTaskTeamData, ThrowOnError>): RequestResult<UpdateDailyTaskTeamResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateDailyTaskTeamResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/{team_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Daily Task Team Participants
 */
export const listDailyTaskTeamParticipants = <ThrowOnError extends boolean = false>(options: Options<ListDailyTaskTeamParticipantsData, ThrowOnError>): RequestResult<ListDailyTaskTeamParticipantsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListDailyTaskTeamParticipantsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/{team_id}/participants/',
    ...options
});

/**
 * Set Daily Task Team Participants
 *
 * PUT replaces participants. Each is detached from its current
 * daily-task-team first (mirrors DRF action).
 */
export const setDailyTaskTeamParticipants = <ThrowOnError extends boolean = false>(options: Options<SetDailyTaskTeamParticipantsData, ThrowOnError>): RequestResult<SetDailyTaskTeamParticipantsResponses, unknown, ThrowOnError> => (options.client ?? client).put<SetDailyTaskTeamParticipantsResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/{team_id}/participants/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Daily Tasks
 */
export const listDailyTasks = <ThrowOnError extends boolean = false>(options: Options<ListDailyTasksData, ThrowOnError>): RequestResult<ListDailyTasksResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListDailyTasksResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-tasks/',
    ...options
});

/**
 * Create Daily Task
 */
export const createDailyTask = <ThrowOnError extends boolean = false>(options: Options<CreateDailyTaskData, ThrowOnError>): RequestResult<CreateDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateDailyTaskResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-tasks/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * My Daily Tasks
 *
 * List the daily tasks assigned to the current user, today.
 */
export const myDailyTasks = <ThrowOnError extends boolean = false>(options: Options<MyDailyTasksData, ThrowOnError>): RequestResult<MyDailyTasksResponses, unknown, ThrowOnError> => (options.client ?? client).get<MyDailyTasksResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-tasks/my-daily-tasks/',
    ...options
});

/**
 * Destroy Daily Task
 */
export const destroyDailyTask = <ThrowOnError extends boolean = false>(options: Options<DestroyDailyTaskData, ThrowOnError>): RequestResult<DestroyDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyDailyTaskResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-tasks/{task_id}/',
    ...options
});

/**
 * Retrieve Daily Task
 */
export const retrieveDailyTask = <ThrowOnError extends boolean = false>(options: Options<RetrieveDailyTaskData, ThrowOnError>): RequestResult<RetrieveDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveDailyTaskResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-tasks/{task_id}/',
    ...options
});

/**
 * Patch Daily Task
 */
export const patchDailyTask = <ThrowOnError extends boolean = false>(options: Options<PatchDailyTaskData, ThrowOnError>): RequestResult<PatchDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchDailyTaskResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-tasks/{task_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Daily Task
 */
export const updateDailyTask = <ThrowOnError extends boolean = false>(options: Options<UpdateDailyTaskData, ThrowOnError>): RequestResult<UpdateDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateDailyTaskResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-tasks/{task_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Team Daily Tasks
 */
export const listTeamDailyTasks = <ThrowOnError extends boolean = false>(options: Options<ListTeamDailyTasksData, ThrowOnError>): RequestResult<ListTeamDailyTasksResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListTeamDailyTasksResponses, unknown, ThrowOnError>({
    responseTransformer: listTeamDailyTasksResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/team-daily-tasks/',
    ...options
});

/**
 * Create Team Daily Task
 */
export const createTeamDailyTask = <ThrowOnError extends boolean = false>(options: Options<CreateTeamDailyTaskData, ThrowOnError>): RequestResult<CreateTeamDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateTeamDailyTaskResponses, unknown, ThrowOnError>({
    responseTransformer: createTeamDailyTaskResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/team-daily-tasks/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Team Daily Task
 */
export const destroyTeamDailyTask = <ThrowOnError extends boolean = false>(options: Options<DestroyTeamDailyTaskData, ThrowOnError>): RequestResult<DestroyTeamDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyTeamDailyTaskResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/team-daily-tasks/{tdt_id}/',
    ...options
});

/**
 * Retrieve Team Daily Task
 */
export const retrieveTeamDailyTask = <ThrowOnError extends boolean = false>(options: Options<RetrieveTeamDailyTaskData, ThrowOnError>): RequestResult<RetrieveTeamDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveTeamDailyTaskResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveTeamDailyTaskResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/team-daily-tasks/{tdt_id}/',
    ...options
});

/**
 * Patch Team Daily Task
 *
 * All TeamDailyTask fields are required, so PATCH must carry the full
 * body too; keeping a distinct handler preserves unique operationIds.
 */
export const patchTeamDailyTask = <ThrowOnError extends boolean = false>(options: Options<PatchTeamDailyTaskData, ThrowOnError>): RequestResult<PatchTeamDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchTeamDailyTaskResponses, unknown, ThrowOnError>({
    responseTransformer: patchTeamDailyTaskResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/team-daily-tasks/{tdt_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Team Daily Task
 */
export const updateTeamDailyTask = <ThrowOnError extends boolean = false>(options: Options<UpdateTeamDailyTaskData, ThrowOnError>): RequestResult<UpdateTeamDailyTaskResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateTeamDailyTaskResponses, unknown, ThrowOnError>({
    responseTransformer: updateTeamDailyTaskResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/team-daily-tasks/{tdt_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List For Team
 */
export const listForTeam = <ThrowOnError extends boolean = false>(options: Options<ListForTeamData, ThrowOnError>): RequestResult<ListForTeamResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListForTeamResponses, unknown, ThrowOnError>({
    responseTransformer: listForTeamResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/{team_id}/team-daily-tasks/',
    ...options
});

/**
 * Retrieve For Team
 */
export const retrieveForTeam = <ThrowOnError extends boolean = false>(options: Options<RetrieveForTeamData, ThrowOnError>): RequestResult<RetrieveForTeamResponses, unknown, ThrowOnError> => (options.client ?? client).get<RetrieveForTeamResponses, unknown, ThrowOnError>({
    responseTransformer: retrieveForTeamResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/daily-task-teams/{team_id}/team-daily-tasks/{tdt_id}/',
    ...options
});

/**
 * List Availabilities
 */
export const listAvailabilities = <ThrowOnError extends boolean = false>(options: Options<ListAvailabilitiesData, ThrowOnError>): RequestResult<ListAvailabilitiesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListAvailabilitiesResponses, unknown, ThrowOnError>({
    responseTransformer: listAvailabilitiesResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/trainer-availabilities/',
    ...options
});

/**
 * Create Availability
 */
export const createAvailability = <ThrowOnError extends boolean = false>(options: Options<CreateAvailabilityData, ThrowOnError>): RequestResult<CreateAvailabilityResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateAvailabilityResponses, unknown, ThrowOnError>({
    responseTransformer: createAvailabilityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/trainer-availabilities/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Availability
 */
export const deleteAvailability = <ThrowOnError extends boolean = false>(options: Options<DeleteAvailabilityData, ThrowOnError>): RequestResult<DeleteAvailabilityResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteAvailabilityResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/trainer-availabilities/{avail_id}/',
    ...options
});

/**
 * Patch Availability
 */
export const patchAvailability = <ThrowOnError extends boolean = false>(options: Options<PatchAvailabilityData, ThrowOnError>): RequestResult<PatchAvailabilityResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchAvailabilityResponses, unknown, ThrowOnError>({
    responseTransformer: patchAvailabilityResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/trainer-availabilities/{avail_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Availabilities
 */
export const listMyAvailabilities = <ThrowOnError extends boolean = false>(options: Options<ListMyAvailabilitiesData, ThrowOnError>): RequestResult<ListMyAvailabilitiesResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListMyAvailabilitiesResponses, unknown, ThrowOnError>({
    responseTransformer: listMyAvailabilitiesResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/{user_id}/trainer-availabilities/',
    ...options
});

/**
 * List Calls
 */
export const listCalls = <ThrowOnError extends boolean = false>(options: Options<ListCallsData, ThrowOnError>): RequestResult<ListCallsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListCallsResponses, unknown, ThrowOnError>({
    responseTransformer: listCallsResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/trainer-calls/',
    ...options
});

/**
 * Create Call
 */
export const createCall = <ThrowOnError extends boolean = false>(options: Options<CreateCallData, ThrowOnError>): RequestResult<CreateCallResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateCallResponses, unknown, ThrowOnError>({
    responseTransformer: createCallResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/trainer-calls/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Call
 */
export const cancelCall = <ThrowOnError extends boolean = false>(options: Options<CancelCallData, ThrowOnError>): RequestResult<CancelCallResponses, unknown, ThrowOnError> => (options.client ?? client).delete<CancelCallResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/trainer-calls/{call_id}/',
    ...options
});

/**
 * Update Call
 */
export const updateCall = <ThrowOnError extends boolean = false>(options: Options<UpdateCallData, ThrowOnError>): RequestResult<UpdateCallResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateCallResponses, unknown, ThrowOnError>({
    responseTransformer: updateCallResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/meetings/{meeting_id}/trainer-calls/{call_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Trainer Profile
 */
export const getTrainerProfile = <ThrowOnError extends boolean = false>(options: Options<GetTrainerProfileData, ThrowOnError>): RequestResult<GetTrainerProfileResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetTrainerProfileResponses, unknown, ThrowOnError>({
    responseTransformer: getTrainerProfileResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/{user_id}/trainer-profile/',
    ...options
});

/**
 * Patch Trainer Profile
 */
export const patchTrainerProfile = <ThrowOnError extends boolean = false>(options: Options<PatchTrainerProfileData, ThrowOnError>): RequestResult<PatchTrainerProfileResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchTrainerProfileResponses, unknown, ThrowOnError>({
    responseTransformer: patchTrainerProfileResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/{user_id}/trainer-profile/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Trainer Profile
 */
export const updateTrainerProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateTrainerProfileData, ThrowOnError>): RequestResult<UpdateTrainerProfileResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateTrainerProfileResponses, unknown, ThrowOnError>({
    responseTransformer: updateTrainerProfileResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/{user_id}/trainer-profile/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List User Diplomas
 */
export const listUserDiplomas = <ThrowOnError extends boolean = false>(options: Options<ListUserDiplomasData, ThrowOnError>): RequestResult<ListUserDiplomasResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListUserDiplomasResponses, unknown, ThrowOnError>({
    responseTransformer: listUserDiplomasResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/{user_id}/diplomas/',
    ...options
});

/**
 * Create Diploma
 */
export const createDiploma = <ThrowOnError extends boolean = false>(options: Options<CreateDiplomaData, ThrowOnError>): RequestResult<CreateDiplomaResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateDiplomaResponses, unknown, ThrowOnError>({
    responseTransformer: createDiplomaResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/{user_id}/diplomas/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Destroy Diploma
 */
export const destroyDiploma = <ThrowOnError extends boolean = false>(options: Options<DestroyDiplomaData, ThrowOnError>): RequestResult<DestroyDiplomaResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DestroyDiplomaResponses, unknown, ThrowOnError>({
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/{user_id}/diplomas/{diploma_id}/',
    ...options
});

/**
 * Patch Diploma
 */
export const patchDiploma = <ThrowOnError extends boolean = false>(options: Options<PatchDiplomaData, ThrowOnError>): RequestResult<PatchDiplomaResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchDiplomaResponses, unknown, ThrowOnError>({
    responseTransformer: patchDiplomaResponseTransformer,
    security: [{
            key: 'JWTNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }, {
            key: 'QRCodeNinjaAuth',
            scheme: 'bearer',
            type: 'http'
        }],
    url: '/api/v2/users/{user_id}/diplomas/{diploma_id}/',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
